import { getApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// Obtener de Firebase Console → Project Settings → Cloud Messaging → Web Push certificates → Generate key pair
const VAPID_KEY = 'BAAEGOysl1WgTvwZulQB1K1zgobpKx6KV3NLSp0G57Sy5RIaHIedtO3He3Fsr0siEw0A25xURWPQCeIx2VsD8o0';

export async function requestPushPermissionAndGetToken(): Promise<string | null> {
    if (!('Notification' in window) || !('serviceWorker' in navigator)) {
        console.warn('[Push] Notifications or ServiceWorker not supported');
        return null;
    }
    if (Notification.permission === 'denied') {
        console.warn('[Push] Permission is denied');
        return null;
    }
    console.log('[Push] Requesting permission, current state:', Notification.permission);
    try {
        const permission = await Notification.requestPermission();
        console.log('[Push] Permission result:', permission);
        if (permission !== 'granted') {
            return null;
        }
        const app = getApp();
        const messaging = getMessaging(app);
        await navigator.serviceWorker.register('/firebase-messaging-sw.js');
        // Esperar a que el SW esté activo antes de suscribir
        const sw = await navigator.serviceWorker.ready;
        console.log('[Push] ServiceWorker active, getting FCM token...');
        const token = await getToken(messaging, { vapidKey: VAPID_KEY, serviceWorkerRegistration: sw });
        console.log('[Push] Token obtained:', token ? 'yes' : 'null/empty');
        return token || null;
    } catch (err) {
        console.error('[Push] Error getting FCM token:', err);
        return null;
    }
}

export function setupForegroundMessageHandler(onReceive: (payload: any) => void): () => void {
    const app = getApp();
    const messaging = getMessaging(app);
    return onMessage(messaging, onReceive);
}
